export default {
    data() {
        return {
            isH5: false
        }
    },
    methods: {
        handleResize() {
            let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            if (width < 750) {
                this.isH5 = true
            } else {
                this.isH5 = false
            }
        },
    },
    created() {
        this.isH5 = window.innerWidth < 750
        window.addEventListener('resize', this.handleResize)
    },
}


// WEBPACK FOOTER //
// ./src/mixins/resizeMixin.js